import { cn } from '@/lib/utils/helpers'
import type { MatchingAutomationMode } from '../types'

const MODE_STYLES: Record<MatchingAutomationMode, string> = {
  ENABLED: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  SHADOW: 'border-amber-200 bg-amber-50 text-amber-700',
  DISABLED: 'border-rose-200 bg-rose-50 text-rose-700',
}

const SELECT_BASE =
  'h-9 min-w-[120px] rounded-full border px-3 text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-[rgb(21,151,255)]/30 disabled:opacity-60'

export function modeSelectClassName(mode?: string | null): string {
  const key = (mode || 'DISABLED') as MatchingAutomationMode
  return cn(SELECT_BASE, MODE_STYLES[key] || MODE_STYLES.DISABLED)
}

export function ModeSelect({
  value,
  disabled,
  onChange,
  id,
  className,
}: {
  value: MatchingAutomationMode | string
  disabled?: boolean
  onChange: (value: MatchingAutomationMode) => void
  id?: string
  className?: string
}) {
  const mode = (value || 'DISABLED') as MatchingAutomationMode
  return (
    <select
      id={id}
      value={mode}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value as MatchingAutomationMode)}
      className={cn(modeSelectClassName(mode), className)}
    >
      <option value="ENABLED">Enabled</option>
      <option value="SHADOW">Shadow</option>
      <option value="DISABLED">Disabled</option>
    </select>
  )
}
